import { useState } from 'react';
import { AppBar, Toolbar, Typography, Box, IconButton, Drawer, List, ListItem, Button } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ContactButton from './ContactButton';

const Navbar = () => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  
  const toggleMenu = () => {
    setMenuIsOpen(!menuIsOpen);
  };
  
  const pages = [
    {name: 'Products', path: '/products'},
    {name: 'Pricing', path: '/pricing'},
    {name: 'Blog', path: '/blog'}
  ];
  
  return (
    <AppBar position="fixed" elevation={0} sx={{width: "100%", background: "rgba(0,0,0,.5)", backdropFilter: "4px", color: "#fff", justifyContent: "space-between",  px: {xs: "5vw", sm:"10vw"}, py: {xs: "6px", sm: "12px"}, margin: "0 auto"}}>
    <Box width="100%">
      <Toolbar disableGutters>
        {/* Mobile */}
        <Typography
          variant="h5"
          noWrap
          component="a"
          href="/"
          sx={{
            fontFamily: 'Orbitron',
            letterSpacing: '.3rem',
            textAlign: 'center',
            mr: 2,
            display: { xs: 'flex', md: 'none' },
            flexGrow: 1
          }}
        >
          CYBERBADGE
        </Typography>
        {/* <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
          <IconButton
            size="large"
            aria-haspopup="true"
            onClick={toggleMenu}
            color="inherit"
          >
            <MenuIcon />
          </IconButton>
        </Box>
        <Drawer anchor="right" open={menuIsOpen} onClose={toggleMenu} sx={{background: "rgba(0,0,0,.25)", backdropFilter: "4px", color: "#fff"}}>
          <List sx={{background: "#0a0a0a", backdropFilter: "4px", color: "#fff", height: "100vh", width: "75vw", display: "flex", flexDirection: "column", justifyContent: "center", padding: "1rem 2rem"}}>
            <ListItem key="contact" onClick={() => {scrollToContact}} sx={{marginBottom: {xs: "1.5rem", sm:"2rem"}}}>
              <Typography variant="body1" component="a" href="/">Home</Typography>
            </ListItem>
            {pages.map((page) => (
              <ListItem key={page.name} onClick={() => {toggleMenu}} sx={{marginBottom: {xs: "1.5rem", sm:"2rem"}}}>
                <Typography variant="body1" component="a" href={page.path}>{page.name}</Typography>
              </ListItem>
            ))}
              <ListItem key="contact" >
                <Typography variant="body1" component="a" onClick={scrollToContact}>Contact</Typography>
              </ListItem>
          </List>
        </Drawer> */}

        {/* Descktop */}
        <Typography
          variant="h6"
          noWrap
          component="a"
          href="/"
          sx={{
            mr: 2,
            display: { xs: 'none', md: 'flex' },
          }}
        >
          CYBERBADGE
        </Typography>

        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: "flex-end" }}>
          {/* {pages.map((page) => (
            <Typography
              variant="body1"
              component="a"
              href={page.path}
              onClick={() => setMenuIsOpen(false)}
              sx={{ mx: "1.5rem", my: "auto", display: 'block', fontSize: "1.2rem", fontWeight: "500" }}
            >
              {page.name}
            </Typography>
          ))} */}
          
          <ContactButton onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })} />
        </Box>
      </Toolbar>
    </Box>
  </AppBar>
  )
}

export default Navbar